module.exports = __webpack_public_path__ + "b5f5fc4755cd2a66cc7d9d81457e5d5b.jpg";